export const STATUS = {
  active: ["Active", "bg-green-50 text-green-700 border-green-200"],
  suspended: ["Suspendue", "bg-amber-50 text-amber-700 border-amber-200"],
  expired: ["Expirée", "bg-stone-100 text-stone-600 border-stone-200"],
  revoked: ["Révoquée", "bg-red-50 text-red-700 border-red-200"],
};

export const KeyStatus = ({ status, testId }) => {
  const [label, cls] = STATUS[status] || STATUS.active;
  return <span className={`inline-flex rounded-full border px-2.5 py-0.5 text-xs font-medium ${cls}`} data-testid={testId}>{label}</span>;
};

export const fullBase = (base) => `${process.env.REACT_APP_BACKEND_URL}${base || "/api/partner/v1"}`;
